import { DragNDrop } from '@/src/components';
import { get } from 'lodash';
import React from 'react';
import AddModule from 'src/components/Modules-revamp/AddModule';
import { Form } from 'src/components/RcForm';
import ContentModuleItem from 'src/components/SalesChannelComponents/ContentModuleItem';
import { generateContentModule } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import Visibility from 'src/components/Modules-revamp/VisibilityDisplay';

const ModuleList = (props) => {
  const {
    listKey,
    listForm,
    onClick,
    onAdd,
    errorDisplay,
    onDelete,
    onDuplicate,
    selectedItem,
    visibleDisplay,
  } = props;

  const renderChild = (
    item: any,
    provided: any,
    index: number,
    additionalProps: any,
  ) => {
    const draggableId = get(item, 'draggableId');
    const { fields, form, remove, add } = additionalProps;
    const itemNamePrefix = fields[index]['name'];
    const v = listForm.getFieldValue([listKey, index]);
    const { uuid } = v;
    const handleOnRemove = () => {
      remove(index);
      onDelete(draggableId);
    };
    return (
      <ContentModuleItem
        hideVisibleDropdownSetting
        isSelected={selectedItem === draggableId}
        onDelete={handleOnRemove}
        dragger={provided.dragHandleProps}
        itemNamePrefix={itemNamePrefix}
        index={index}
        key={uuid}
        form={form}
        listKey={listKey}
        onDuplicate={(draId) => {
          if (onDuplicate) {
            onDuplicate(draId, add);
          }
        }}
        onClick={() => {
          if (onClick) {
            onClick(draggableId);
          }
          //
        }}
        errorDisplay={errorDisplay}
        CustomVisible={
          <Visibility
            {...(visibleDisplay || {})}
            currentDraggableId={draggableId}
          />
        }
      />
    );
  };
  return (
    <Form.List name={listKey}>
      {(fields, { add, move, remove }) => {
        const mFields = fields.map((i, index) => {
          const { name } = i;
          const v = listForm.getFieldValue([listKey, name]);
          const { draggableId } = v;
          return { ...i, draggableId };
        });

        return (
          <React.Fragment>
            <AddModule
              onClick={(type) => {
                const nObj = generateContentModule(type);
                const draggableId = get(nObj, 'pc.draggableId');
                const moduleType = get(nObj, 'pc.moduleType');
                const moduleName = get(nObj, 'pc.moduleName');
                const uuid = get(nObj, 'pc.uuid');
                const nV = { draggableId, moduleType, moduleName, uuid };
                add(nV);
                onAdd(nObj);
              }}
            />
            <DragNDrop
              droppableId={'test'}
              list={mFields}
              childGenerator={renderChild}
              onChange={(from, to) => {
                move(to, from);
              }}
              additionalPropsToItem={{
                fields,
                form: listForm,
                remove,
                add,
                // index,
              }}
            />
          </React.Fragment>
        );
      }}
    </Form.List>
  );
};
export default ModuleList;
